<template>
    <div>
        <div class="flex jcbc p14-9">

            <div class="flex w66 alc">
<!--                <el-select v-model="i_state" size="mini" @change="searchFun" style="margin-right: 9px; ">-->
<!--                    <el-option v-for="item in isuseList" :key="item.key" :label="item.label" :value="item.key"></el-option>-->
<!--                </el-select>-->
                <el-input  class="marr4" style=""  v-model="vc_search" placeholder="请输入银行名称" clearable size="mini"></el-input>
                <el-button class="marr4" icon="el-icon-search" circle  @click="searchFun" size="mini"></el-button>
            </div>
            <el-button class="marB10" @click="addFun" :class="baseerp+'btn'" size="mini">
                新增
            </el-button>
        </div>

        <el-table
                class="mrt10" ref="table" size="mini" :height="tableHeight" border :data="tableData"
                :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column  prop="i_id" label="银行ID" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_name" label="银行名称" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_pname" label="所属总行" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="i_state" label="是否启用" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.i_state==-1?'否':'是'}}</span>
                </template>
            </el-table-column>
            <el-table-column  prop="vc_lruname" label="录入人" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="dt_createtime" label="录入时间" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                    <el-button  size="mini" type="text" @click="detailsFun(scope.row)" >详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  style="margin-top: 10px;text-align: right" background @current-change="pageCurrentChange" layout="total,prev, pager, next"
                        :current-page.sync="currentPage" :total="total" :page-size="pageSize">
        </el-pagination>
        <div :class="baseerp+'div'">
            <el-dialog :title="yhtitle" width="500"  :visible.sync="dialogYhVisible"
                       :close-on-click-modal="false" @close="closeYhFun">
                <bank-page :data="yhProp" v-if="dialogYhVisible" @close="closeYhFun"></bank-page>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";
    import BankPage from "./BankPage";

    export default {
        name: "index",
        components: {BankPage},
        props: {},
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                tableData:[],
                currentPage:1,
                pageSize:20,
                total:0,
                dialogBankVisible:false,
                dialogYhVisible:false,
                yhProp:{},
                yhtitle:'',
                isuseList:[{key:-1,label:'已禁用'},{key:0,label:'已启用'}],
                i_state:0,
                vc_search:'',
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.$nextTick(() => {
                this.onResize();
            })
            this.getBankDictList()
        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.2;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            searchFun(){
                this.currentPage=1
                this.getBankDictList()
            },
            addFun(){
                this.dialogYhVisible=true;
                this.yhtitle='新增银行';
                this.yhProp={
                    i_id:0
                }
            },
            detailsFun(val){
                this.dialogYhVisible=true;
                this.yhtitle='编辑银行';
                this.yhProp=val
            },
            closeYhFun(type='back'){
                this.dialogYhVisible=false;
                if(type=='save'){
                    this.currentPage=1
                    this.getBankDictList()
                }
                this.yhProp=null
            },
            pageCurrentChange(val){
                this.currentPage=val;
                this.getBankDictList()
            },
            async getBankDictList(){
                let param={
                    // i_state:this.i_state,
                    vc_search:this.vc_search,
                    pageSize: 20,
                    currentPage:this.currentPage
                };
                let res=await API.getBankDictList(param);
                if ( res.code == 1 ){
                    this.tableData=res.data.bankDictList;
                    this.total=res.data.count;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .jcbc{
        justify-content: space-between;
    }
    .p14-9{
        padding: 14px 9px;
    }
</style>